import React from 'react';
import SEOHead from '../components/SEOHead';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import WhyUsSection from '../components/WhyUsSection';
import AboutSection from '../components/AboutSection';
import PricingSection from '../components/PricingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import useCanonical from '../hooks/useCanonical';

const Home = () => {
  useCanonical('https://validatedboat.fr/');
  return (
    <>
      <SEOHead />
      <div className="min-h-screen bg-[#1a1c1b]">
        <Header />
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <AboutSection />
        <PricingSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
};

export default Home;